import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface IToast {
  content: string;
  delay: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  subject = new BehaviorSubject<IToast | null>(null);
  toast$ = this.subject.asObservable().pipe(filter((toast) => toast !== null));

  show(content: string, delay = 3000) {
    this.subject.next({ content, delay });
  }
}
